$ = require 'jquery'
Browser = require '@trello/browser'
Controller = require 'app/scripts/controller'
PopOver = require 'app/scripts/views/lib/pop-over'
PostRender = require 'app/scripts/views/lib/post-render'
SidebarState = require 'app/scripts/view-models/sidebar-state'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
{ track } = require '@trello/analytics'

pointHorizontallyInRect = ({ x }, { left, right }) ->
  left <= x < right

inset = ({ top, left, bottom, right }, horizontal, vertical) ->
  top: top + vertical
  bottom: bottom - vertical
  left: left + horizontal
  right: right - horizontal

getMousePosition = (e) ->
  x: e.pageX
  y: e.pageY

# TODO: good candidate for effing.js
concat = (fns...) ->
  return ->
    for fn in fns when fn?
      fn.apply(this, arguments)
    return

prefix = (fn, prefix) -> concat prefix, fn

class DragInfo
  hasMousedLeft: false
  hasMousedRight: false
  stopped: false
  aborted: false
  constructor: ({ @scrollBoard, @scrollLists, @commitEvent, @cancelMethod }) ->
    @_queue = []

  start: (e, ui) ->
    @$helper = ui.helper
    @$target = $(e.target)
    @initialMousePosition = getMousePosition(e)

    @lockModelCache()
    SidebarState.hideSidebar()
    @startTrackingMouse()
    @hidePopoversForSomeReason()

    @boardElement = $('#board')[0]
    @boardCanvasElement = $('.board-canvas')[0]

    @cachedHoveredList = @getHoveredListForPoint(@initialMousePosition)
    if @scrollLists || @scrollBoard
      @startAutoscrolling()

    DragSort.sorting = true
    @onStop ->
      # This fixes a timing issue where cards sometimes open after dragging.
      # If sorting is cleared too early, the card click will go through.
      # Observed in Firefox.
      # Obviously there are better ways to fix this.
      _.defer ->
        DragSort.sorting = false
    return

  lockModelCache: ->
    modelCache = Controller.getCurrentModelCache()
    if !modelCache?
      throw new Error "Attempt to use DragInfo on a page with no modelCache!"
    _lockIndex = modelCache.lock 'DragSort.startSort'
    @onStop -> modelCache.unlock _lockIndex

  hidePopoversForSomeReason: ->
    # If you're dragging a member from the "N observers" section,
    # we don't want to hide this.
    if @$target.closest('.pop-over').length == 0
      PopOver.hide()
    return

  startAutoscrolling: ->
    autoScrollRate = Math.floor(1000 / 60)
    scrollInterval = setInterval(@autoscroll.bind(@), autoScrollRate)
    @onStop -> clearInterval scrollInterval

  getHoveredListForPoint: (point) ->
    for el in $('.js-list')
      if pointHorizontallyInRect point, el.getBoundingClientRect()
        return $(el).find('.list-cards')[0]
    return null

  startTrackingMouse: ->
    updateHoveredList = _.throttle (point) =>
      # Because this is throttled, it's possible that it'll fire
      # after the drag has stopped. That would be madness.
      if @stopped
        return
      @cachedHoveredList = @getHoveredListForPoint(point)
    , 100

    tolerance = 20
    $(document).on 'mousemove.dragsort', (e) =>
      mousePosition = getMousePosition(e)
      if mousePosition.x < (@initialMousePosition.x - tolerance)
        @hasMousedLeft = true
      if mousePosition.x > (@initialMousePosition.x + tolerance)
        @hasMousedRight = true
      updateHoveredList mousePosition
      return

    @onStop -> $(document).off 'mousemove.dragsort'

  onStop: (fn) ->
    @_queue.push fn

  stop: (e, ui) ->
    @stopped = true

    for fn in @_queue
      fn.call this
    delete @_queue

    if !@aborted
      @$target.trigger @commitEvent, ui

    return

  scrollDeltaForOverhang: (overhang) -> overhang * 0.1

  autoscrollBoard: ->
    { left, right } = @$helper[0].getBoundingClientRect()
    scrollFrame = inset @boardCanvasElement.getBoundingClientRect(), 100, 0

    leftOverhang = scrollFrame.left - left
    if leftOverhang > 0 && @hasMousedLeft
      @boardElement.scrollLeft -= @scrollDeltaForOverhang leftOverhang

    rightOverhang = right - scrollFrame.right
    if rightOverhang > 0 && @hasMousedRight
      @boardElement.scrollLeft += @scrollDeltaForOverhang rightOverhang

    return

  autoscrollLists: ->
    { top, bottom } = @$helper[0].getBoundingClientRect()
    scrollFrame = inset @cachedHoveredList.getBoundingClientRect(), 0, 50

    topOverhang = scrollFrame.top - top
    if topOverhang > 0
      @cachedHoveredList.scrollTop -= @scrollDeltaForOverhang topOverhang

    bottomOverhang = bottom - scrollFrame.bottom
    if bottomOverhang > 0
      @cachedHoveredList.scrollTop += @scrollDeltaForOverhang bottomOverhang

    return

  autoscroll: ->
    if @scrollBoard
      @autoscrollBoard()
    if @scrollLists && @cachedHoveredList?
      @autoscrollLists()
    return

  abort: ->
    @aborted = true
    # Work around a bug in jQueryUI Sortable
    # If the drag manager thinks that the element has switched sortable
    # containers, it will fire a receive event on the new container, even
    # though the drag has been cancelled
    if (manager = $.ui.ddmanager.current)?
      manager.currentContainer = manager

    @$target[@cancelMethod] 'cancel'

currentDragInfo = null

normalizeOpts = (customOpts, opts) ->
  opts = _.defaults {}, opts,
    distance: 7
    scroll: false

  # This allows you to drag cards over the "Add a card..." button at the
  # bottom of lists (even though that isn't inside their destination).
  if customOpts.scrollLists
    opts.custom = refreshContainers: ->
      @containers = for container in @containers \
                    when $.contains(document, container.element[0])
        el = container.element.closest('.js-list')[0]
        frame = el.getBoundingClientRect()
        for field in ['left', 'top', 'width', 'height']
          container.containerCache[field] = frame[field]
        container
      return

  opts.start = prefix opts.start, (e, ui) ->
    if currentDragInfo?
      throw new Error "Attempt to start a drag event while another is in progress!"
    currentDragInfo = new DragInfo(customOpts)
    currentDragInfo.start(e, ui)
    return

  opts.stop = prefix opts.stop, (e, ui) ->
    Util.stopPropagation(e)
    currentDragInfo.stop(e, ui)
    currentDragInfo = null
    return

  return opts

defaultCalcSize = ($item) ->
  width: $item.outerWidth()
  height: $item.outerHeight()

hookSortable = (selector, customOpts, opts) ->
  if Browser.isTouch()
    return
  $elements = null

  shouldNormalizeAppendTo = 'helper' not of opts || opts.helper == 'original'
  opts.start = prefix opts.start, (e, ui) ->
    if shouldNormalizeAppendTo && 'appendTo' of opts
      ui.helper.appendTo opts.appendTo
      $elements.sortable 'refreshPositions', true
    { width, height } = (customOpts.calcSize ? defaultCalcSize)(ui.item)
    ui.placeholder.width width
    ui.placeholder.height height
    return

  customOpts = _.extend
    commitEvent: 'sortcommit'
    cancelMethod: 'sortable'
  , customOpts
  opts = normalizeOpts customOpts, opts

  PostRender.enqueue ->
    $elements = $(selector)
    $elements.sortable opts
  return

hookDraggable = (selector, customOpts, opts) ->
  if Browser.isTouch()
    return
  customOpts = _.extend
    commitEvent: 'dragcommit'
    cancelMethod: 'draggable'
  , customOpts
  opts = normalizeOpts customOpts, opts
  PostRender.enqueue ->
    $(selector).draggable opts
  return

module.exports = DragSort =
  refreshListSortable: ->
    hookSortable '.js-list-sortable',
      scrollBoard: true
      scrollLists: false
      calcSize: ($listWrapper) ->
        $el = $listWrapper.children('.list')
        width: $el.outerWidth()
        height: $el.outerHeight()
    ,
      handle: '.list-header'
      tolerance: 'pointer'
      placeholder: 'list-wrapper placeholder'
      items: '.js-list'
      appendTo: '#trello-root'

  refreshCalendarCardSortable: ->
    hookSortable '.js-calendar-sortable',
      scrollBoard: false
      scrollLists: false
    ,
      connectWith: '.js-calendar-sortable'
      placeholder: 'list-card placeholder-none'
      items: '.list-card:not(.placeholder-none, .hide, .js-composer)'
      appendTo: '.calendar-drag-area'

      over: (e, ui) -> $(e.target).closest('.calendar-day').addClass('drop')
      out: (e, ui) -> $(e.target).closest('.calendar-day').removeClass('drop')

  refreshListCardSortable: ->
    hookSortable '.js-sortable',
      scrollBoard: true
      scrollLists: true
    ,
      connectWith: '.js-sortable:not(.card-limits-full)'
      placeholder: 'list-card placeholder'
      items: '.list-card:not(.placeholder, .hide, .js-composer)'
      appendTo: '#trello-root'

  refreshDraggableSidebarMembers: ->
    hookDraggable '.js-list-draggable-board-members
                   .member:not(.js-member-deactivated)',
      scrollBoard: true
      scrollLists: true
    ,
      revert: 'invalid'
      revertDuration: 150
      appendTo: '#trello-root'
      zIndex: 100
      helper: 'clone'
      start: (e, ui) ->
        track('Board Menu', 'Drag Member from Sidebar')

        # droppable.hoverClass in card.coffee is going to add an active class
        # so we don't want it to look like there are two active cards
        $('.list-card.active-card').removeClass('active-card')
        return

  refreshDraggableStickers: ->
    hookDraggable '.js-draggable-sticker:not(.disabled)',
      scrollBoard: true
      scrollLists: true
    ,
      revert: 'invalid'
      revertDuration: 150
      appendTo: '#trello-root'
      zIndex: 100
      helper: 'clone'
      start: (e, ui) ->
        track('Board Menu', 'Drag Sticker from Sidebar')
        randomRotation = (Math.random() * 20) - 10
        ui.helper.find('.sticker-select-fixed').css
          'transform': "rotate(#{ randomRotation }deg)"
          '-webkit-transform': "rotate(#{ randomRotation }deg)"
        return

  abort: ->
    if !currentDragInfo?
      throw new Error "Abort called while not dragging!"
    currentDragInfo.abort()

  refreshIfInitialized: ($el) ->
    # The first drag after a card add fails in jQuery 2.0.0
    # see http://bugs.jquery.com/ticket/13907 and https://trello.com/c/Gul0vmVu
    # The presence of the ui-sortable class is our only real proxy for init'd
    if $el?.hasClass('ui-sortable')
      $el.sortable('refresh')
